let copiedParamValues: Record<string, string> | null = null;

export function getCopiedParamValues(): Record<string, string> | null {
    return copiedParamValues;
}

export function setCopiedParamValues(values: Record<string, string> | null): void {
    copiedParamValues = values;
}
